// extracted by mini-css-extract-plugin
export var closeButton = "_gl-2";
export var closeButtonIcon = "_gl-3";
export var lightboxContent = "_gl-1";
export var lightboxOverlay = "_gl-0";